import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './PolicyPages.css';

const KVKKForm = () => {
    return (
        <div className="policy-page">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={10}>
                        <h1 className="policy-title text-center mb-5">KVKK Aydınlatma Formu</h1>
                        
                        <div className="policy-content">
                            <p>
                                Veri sorumlusu olarak OTOPRİME ("Şirket") ile paylaştığınız kişisel verilerinizin 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") ve ikincil mevzuat kapsamında güvenliğinin ve gizliliğinin temini, Şirketimizin öncelikleri arasındadır. Bu doğrultuda kişisel verilerinizin, Şirketimiz tarafından, aramızda herhangi bir hukuki ilişki kurulmasa dahi, toplanması, depolanması, kullanılması, aktarılması, muhafaza edilmesi (bir diğer ifadeyle işlenmesi) hakkında aşağıdaki bilgilendirmeleri dikkatinize sunmak isteriz.
                            </p>

                            <h2>1) Kişisel Verileriniz Hangi Amaçlarla İşlenecektir?</h2>
                            <p>Şirketimiz çerezler aracılığı ile topladığı kişisel verilerinizi aşağıda belirtilen amaçlar dahilinde işleyebilecektir:</p>
                            <ol>
                                <li>
                                    (i) reklam faaliyeti gerçekleştirmesi, (ii) web sitesinin kullanımı hakkında bilgi depolamak ve kullanım kolaylığı sağlaması, (iii) web sitesinin çalışması için gerekli temel fonksiyonları gerçekleştirmesi ve (iv) web sitesini analiz etmek, performansını ve işlevselliğini artırması,
                                </li>
                                <li>
                                    Sizinle Şirketimiz arasında web sitesi üyelik hizmeti ilişkisinin kurulabilmesi ve ifa edilebilmesi,
                                </li>
                                <li>
                                    Şirketimizin kısa, orta ve uzun vadede ticari politikalarının tespit edilmesi, planlanması ve uygulanması,
                                </li>
                                <li>
                                    Müşteri hizmetlerimizin/ilişkilerimizin yürütülmesi ve memnuniyetinizin değerlendirilmesi ve bu bağlamda istatistiki çalışmaların yürütülmesi,
                                </li>
                                <li>
                                    Şirketimizin uygulanabilir tüm yasal düzenlemeler kapsamında idari ve hukuki hak ve yükümlülüklerini yerine getirebilmesi.
                                </li>
                            </ol>

                            <h2>2) Kişisel Verileriniz Kimlere ve Hangi Amaçlarla Aktarılacaktır?</h2>
                            <p>Şirketimiz kişisel verilerinizi yukarıda belirtilen amaçlar dahilinde:</p>
                            <ol>
                                <li>
                                    Bakanlıklar, Ticaret Sicil Müdürlükleri, Vergi Daireleri, noterlikler, Mahkemeler, savcılıklar, emniyet teşkilatı ve sair her türlü kamu tüzel kişiler, yasal otoriteler ve resmi mercilere,
                                </li>
                                <li>
                                    Şirketimizin ana hissedarı, doğrudan/dolaylı ve yurtiçi/yurtdışı iştirakleri ve bağlı ortaklıklarına,
                                </li>
                                <li>
                                    Şirketimizin araçlara ilişkin bilgilerin web sitesinde ilan edilmesi, araç alım/satımı faaliyetlerini yürütmek üzere hizmet aldığı/verdiği ve/veya iş birliği yaptığı yurtiçi/yurtdışında bulunan finans, otomotiv, telekomünikasyon, sigorta, arşiv, sunucu (server) barındırma, veri tabanı, veri merkezi, bulut (cloud) platformları, kurye ve sair sektörlerde hizmet veren kurum ve kuruluşlara, bunların tedarikçilerine bayilerine, tedarikçileri ve müşavirlerine ve
                                </li>
                                <li>
                                    yurtiçi/yurtdışında bulunan hukuki, finansal, vergisel ve operasyonel danışmanlarımız ve denetçilerimize aktarabilecektir.
                                </li>
                            </ol>

                            <h2>3) Kişisel Verileriniz Hangi Yöntemler ile Toplamaktayız?</h2>
                            <p>
                                Kişisel verileriniz Şirketimiz tarafından elektronik ortamda yazılı bir şekilde tamamen veya kısmen otomatik yollarla ve bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla toplanabilecektir. Kişisel verileriniz doğrudan doğruya sizden kurumsal internet sitemiz aracılığıyla toplanabilecektir.
                            </p>

                            <h2>4) Kişisel Verilerinizi Toplamamızın Hukuki Sebebi Nedir?</h2>
                            <p>
                                Kişisel verilerinizin Şirketimiz tarafından işlenmesinin hukuki sebebi (i) açık rızanız olması ve (ii) Şirketimizin meşru menfaatleri için zorunlu olmasıdır. Hukuki sebebe ilişkin detaylı bilgilendirme talep edilmesi halinde Şirketimize başvurulmasını rica ederiz.
                            </p>

                            <h2>5) Veri Sahibi Olarak KVKK Kapsamındaki Haklarınız Nelerdir?</h2>
                            <p>Şirketimiz tarafından işlenen kişisel verileriniz bakımından Şirketimize başvurarak, kişisel verilerinizin:</p>
                            <ul>
                                <li>(i) işlenip işlenmediğini öğrenme,</li>
                                <li>(ii) işlenmiş ise bilgi talep etme,</li>
                                <li>(iii) işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                                <li>(iv) yurt içinde / yurt dışında aktarıldığı 3. kişileri bilme,</li>
                                <li>(v) eksik / yanlış işlenmişse düzeltilmesini isteme,</li>
                                <li>(vi) KVKK m. 7'de öngörülen şartlar çerçevesinde silinmesini / yok edilmesini isteme,</li>
                                <li>(vii) verilerinizin aktarıldığı 3. kişilere (v) ile (vi) bentlerindeki işlemlerin bildirilmesini isteme</li>
                                <li>(viii) münhasıran otomatik sistemler ile analiz edilmesi nedeniyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme ve</li>
                                <li>(ix) kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme hakkına sahipsiniz.</li>
                            </ul>

                            <p>
                                Belirtilen haklarınıza ilişkin olarak Şirketimize yazılı olarak otoprime34@gmail.com e-posta adresimiz veya "Kaynarca Mah. Zirve Sok., Optimum Modern Sitesi No:1, 34890 Pendik/İstanbul" olan açık adresimiz üzerinden ulaşabilirsiniz.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default KVKKForm;